import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from "../../components/ui/Icons";
import ReactSelect from "react-select";
import useGymsData from "../../hooks/useGymsData";
import Tabs from "../../components/ui/Tabs";
import LightTable from "../../components/components-bootstrap/LightTable";
import { addDays, format } from "date-fns";
import DateRanger from "../../components/components-react/DateRanger";
import moment from "moment";
import { useGetFetch } from "../../data/Queries";
import {
  gymDashBoardReportsGet,
  gymDashBoardReportsGetKey,
} from "../../data/ApiEndpoints";
import { useSelector } from "react-redux";
import { selectToken } from "../../components/auth/auth.selector";
import { formatDate } from "../../utils/utilityfunc";
import HelmetWrapper from "../../HelmetWrapper";

const SalesPage = () => {
  const token = useSelector(selectToken);
  const tabs = ["All Payments", "Full Payments", "Partial Payments"];
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTabs, setActiveTab] = useState(tabs[0]);
  const trxOpt = [
    { label: "All", value: "all" },
    { label: "Online", value: "online" },
    { label: "Cash", value: "cash" },
  ];

  //gyms
  const {
    data: gymData,
    isLoading: isLoadingGyms,
    isFetching: isFetchingGyms,
  } = useGymsData();

  // date range
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const initalStartandenddateValues = {
    startDate: "",
    endDate: "",
    selectedDates: "",
    selectedDate: "",
  };
  const [dateRangerOpen, setDateRangerOpen] = useState(false);
  const [rangeState, setRangeState] = useState(initialRangeState);
  const [startAndEndDate, setStartAndEndDate] = useState(
    initalStartandenddateValues
  );

  // dashboard-details
  const [isPage, setIsPage] = useState(0);
  const [filters, setFilters] = useState({ limit: 10, filter_type: "today" });
  const {
    data: dashboardReportData,
    isLoading: isLoadingDashboardReport,
    isFetching: isFetchingDashboardReport,
    refetch: refetchDashboardReports,
  } = useGetFetch({
    url: gymDashBoardReportsGet,
    key: gymDashBoardReportsGetKey,
    token,
    isPage: isPage + 1,
    filters,
  });

  const handleDateRangeChange = (item) => {
    try {
      setRangeState([item?.selection]);
      const formattedStartDate = format(
        item?.selection?.startDate,
        "yyyy-MM-dd"
      );
      const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");
      const formattedStart = moment(formattedStartDate).tz("Asia/Kolkata").format("DD-MM-YYYY");
      const formattedEnd = moment(formattedEndDate).tz("Asia/Kolkata").format("DD-MM-YYYY");

      setStartAndEndDate({
        ...startAndEndDate,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        selectedDates: `${formattedStart} to ${formattedEnd}`,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getTitle = () => {
    try {
      const titleParts = `${location?.pathname}`.split("/");

      if (titleParts.includes("today")) {
        // set date range
      }
      return titleParts.join(" ");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    try {
      const { startDate, endDate } = startAndEndDate;
      setFilters({
        ...filters,
        start_date: startDate,
        end_date: endDate,
      });
    } catch (error) {
      console.log(error);
    }
  }, [startAndEndDate]);

  useEffect(() => {
    try {
      refetchDashboardReports();
    } catch (error) {
      console.log(error);
    }
  }, [filters]);

  const paymentsCol = [
    {
      dataField: "name",
      text: "Member Name",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{data}</span>
        </div>
      ),
    },
    {
      dataField: "mobile",
      text: "Mobile",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{data}</span>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{data}</span>
        </div>
      ),
    },
    {
      dataField: "type",
      text: "Type",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{data}</span>
        </div>
      ),
    },
    {
      dataField: "",
      text: "Plan Name",
      formatter: (_, row) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{row?.plan_name || row?.addon_name}</span>
        </div>
      ),
    },
    {
      dataField: "start_date",
      text: "Subscription Start From",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{formatDate(data, "DD, MMM YYYY hh:mm A")}</span>
        </div>
      ),
    },
    {
      dataField: "expire_date",
      text: "Subscription Valid Till",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{formatDate(data, "DD, MMM YYYY hh:mm A")}</span>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Price",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{data ? `₹${data}` : "N/A"}</span>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "Subscription Added",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{formatDate(+data)}</span>
        </div>
      ),
    },
    {
      dataField: "",
      text: "Subscription Status",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{data}</span>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Mode",
      formatter: (data) => (
        <div className="flex-k js-center-k items-center-k">
          <span>{`${data}` === "false" ? "Full" : "Partial"}</span>
        </div>
      ),
    },
  ];

  return (
    <HelmetWrapper title="WTF: Sales Management">
      <div className="container-k small p-0">
        <div>
          <header className="flex-k js-between-k items-center-k">
            <h3 className="bolder-text dark-text fs-large-k capitalise-k">
              {getTitle()}
            </h3>
            <button
              onClick={() => navigate(-1)}
              className="btn-k dark-bg-k flex-k js-center-k items-center-k"
            >
              <Icons name={"leftArrow"} /> Back
            </button>
          </header>

          <div className="grid-k grid-col-2-k gap-1-k my-3">
            <div className="card-k grid-k gap-1-k">
              <header className="flex-k js-between-k border-rounded-1 bottom">
                <h4 className="dark-text bold-text">Revenues</h4>
              </header>
              <div className="flex-k js-between-k border rounded-1 bg-white items-center-k p-2">
                <div className="flex-k items-center-k gap-05-k">
                  <span className="dark-bg-k w-2rem-k aspect-ratio-k rounded-full-k flex-k js-center-k items-center-k">
                    <Icons name="sendIcon" />
                  </span>
                  <span className="bold-text fs-normal-text">Daily Target</span>
                </div>
                <span>0</span>
              </div>
              <div className="flex-k js-between-k border rounded-1 bg-white items-center-k p-2">
                <div className="flex-k items-center-k gap-05-k">
                  <span className="dark-bg-k w-2rem-k aspect-ratio-k rounded-full-k flex-k js-center-k items-center-k">
                    <Icons name="sendIcon" />
                  </span>
                  <span className="bold-text fs-normal-text">
                    Total Earnings
                  </span>
                </div>
                <span>0</span>
              </div>
              <div className="flex-k js-between-k border rounded-1 bg-white items-center-k p-2">
                <div className="flex-k items-center-k gap-05-k">
                  <span className="dark-bg-k w-2rem-k aspect-ratio-k rounded-full-k flex-k js-center-k items-center-k">
                    <Icons name="sendIcon" />
                  </span>
                  <span className="bold-text fs-normal-text">Partial</span>
                </div>
                <span>0</span>
              </div>
              <div className="flex-k js-between-k border rounded-1 bg-white items-center-k p-2">
                <div className="flex-k items-center-k gap-05-k">
                  <span className="dark-bg-k w-2rem-k aspect-ratio-k rounded-full-k flex-k js-center-k items-center-k">
                    <Icons name="sendIcon" />
                  </span>
                  <span className="bold-text fs-normal-text">
                    Total GST Collected
                  </span>
                </div>
                <span>0</span>
              </div>
            </div>
            <div className="card-k">
              <div className="grid-k grid-col-2-k h-fit gap-1-k relative-k">
                <div className="flex-k flex-col-k gap-05-k">
                  <label className="bold-text">Select Gym*</label>
                  <ReactSelect
                    isClearable
                    options={gymData || []}
                    classNamePrefix={"input-k-select"}
                    placeholder="Select Gym"
                    value={
                      gymData &&
                      gymData.find((gym) => gym.value === filters?.gym)
                    }
                    onChange={(opt) =>
                      setFilters({ ...filters, gym_id: opt?.value })
                    }
                  />
                </div>
                <div className="flex-k flex-col-k gap-05-k">
                  <label className="bold-text">Select Date Range*</label>
                  <div>
                    {!dateRangerOpen && startAndEndDate?.selectedDates ? (
                      <button
                        onClick={() => {
                          setDateRangerOpen(true);
                        }}
                        className="fake-input-k px-2 bg-white py-07-k"
                      >
                        {startAndEndDate.selectedDates}
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          setDateRangerOpen(true);
                        }}
                        className="fake-input-k px-2 bg-white py-07-k"
                      >
                        Select Date
                      </button>
                    )}
                  </div>
                  {dateRangerOpen ? (
                    <div className="k-date-ranger top-50-k right-0-k">
                      <div className="flex-k gap-05-k js-end-k bg-white p-2">
                        <button
                          className="btn-k dark-bg-k"
                          onClick={() => setDateRangerOpen(false)}
                        >
                          Close
                        </button>
                        <button
                          className="btn-k dark-bg-k"
                          onClick={() => {
                            setDateRangerOpen(false);
                            setRangeState(initialRangeState);
                            setStartAndEndDate({
                              ...startAndEndDate,
                              startDate: "",
                              endDate: "",
                              selectedDates: "",
                            });
                          }}
                        >
                          Clear
                        </button>
                      </div>
                      <DateRanger
                        handleDateRangeChange={handleDateRangeChange}
                        rangeState={rangeState}
                        onClose={() => setDateRangerOpen(false)}
                        onClear={() => {
                          setDateRangerOpen(false);
                          setRangeState(initialRangeState);
                          setStartAndEndDate({
                            ...startAndEndDate,
                            startDate: "",
                            endDate: "",
                            selectedDates: "",
                          });
                        }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex-k flex-col-k gap-05-k">
                <label className="bold-text">Transaction Type*</label>
                <ReactSelect
                  isClearable
                  options={trxOpt}
                  classNamePrefix={"input-k-select"}
                  placeholder="Select Transaction Type"
                  value={filters?.gym}
                  onChange={(opt) =>
                    setFilters({ ...filters, trx_id: opt?.value })
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="grid-k gap-1-k my-4">
          <Tabs
            tabs={tabs}
            activeTab={activeTabs}
            setActiveTab={setActiveTab}
          />

          <LightTable
            columns={paymentsCol}
            data={
              (dashboardReportData?.data &&
                dashboardReportData?.data?.fullPayments) ||
              []
            }
          />
        </div>
      </div>
    </HelmetWrapper>
  );
};

export default SalesPage;
